import React from "react";
import {Input} from "antd";
import "./SelectSearchInput.scss";

const SelectSearchInput = React.memo(
  ({
    initialList = [],
    listResultCallbackAfterSearch = () => {},
    fieldSearchBy = "name",
    placeholder,
    value,
    addClass = "",
    disabled,
    small,
    tiny,
    uppercase,
    bold,
  }) => {
    const inputStyle = {
      height: tiny ? 34 : small ? 38 : 44,
      border: "none",
      backgroundColor: "transparent",
      borderRadius: 3,
      padding: "0px 30px 0px 10px",
      fontSize: tiny || small ? 12 : 14,
      boxShadow: "inset 1px 1px 4px rgba(0, 0, 0, 0.1)",
      transition: "all 0.3s ease",
      ...(uppercase && {textTransform: "uppercase"}),
      ...(bold && {fontWeight: 700}),
    };

    const wrapperStyle = {
      marginBottom: 8,
      padding: "10px",
      width: "100%",
    };

    const handleSearch = (e) => {
      e.stopPropagation();
      const searchValue = e.target.value;
      const filteredList = initialList.filter((item) => {
        const fieldValue = item[fieldSearchBy];
        return fieldValue && fieldValue.toLowerCase().includes(searchValue.toLowerCase());
      });
      listResultCallbackAfterSearch(filteredList);
    };

    return (
      <div style={wrapperStyle} role="listbox" aria-expanded="false">
        <Input
          type="text"
          className={`select-search-input ant-input ${addClass}`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => handleSearch(e)}
          disabled={disabled}
          style={inputStyle}
        />
      </div>
    );
  }
);

export default SelectSearchInput;
